var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-wrapper" }, [
    _c("div", { staticClass: "__title" }, [_vm._v(_vm._s(_vm.$t("login")))]),
    _vm._v(" "),
    _c("div", { staticClass: "switch-btn" }, [
      _c(
        "div",
        {
          key: "tb",
          staticClass: "btn-item __pointer",
          class: { active: _vm.tabName === "vb" },
          on: {
            click: function($event) {
              return _vm.toggleTab("vb")
            }
          }
        },
        [
          _c("div", { staticClass: "star" }),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("assets.vb.title")) + "\n        "
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isDesktop
        ? _c(
            "div",
            {
              key: "ledger",
              staticClass: "btn-item __pointer",
              class: { active: _vm.tabName === "ledger" },
              on: {
                click: function($event) {
                  return _vm.toggleTab("ledger")
                }
              }
            },
            [
              _c("div", { staticClass: "star" }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("assets.ledger.title")) +
                  "\n        "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isHaveList,
              expression: "isHaveList"
            }
          ],
          key: "existingAcc",
          staticClass: "btn-item __pointer",
          class: { active: _vm.tabName === "existingAcc" },
          on: {
            click: function($event) {
              return _vm.toggleTab("existingAcc")
            }
          }
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("existingAcc")) + "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          key: "resotre",
          staticClass: "btn-item __pointer",
          class: { active: _vm.tabName === "resotre" },
          on: {
            click: function($event) {
              return _vm.toggleTab("resotre")
            }
          }
        },
        [_vm._v("\n            " + _vm._s(_vm.$t("restore")) + "\n        ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content" },
      [
        _vm.tabName === "vb"
          ? _c("div", { staticClass: "vb" }, [
              _c(
                "div",
                { staticClass: "code_container" },
                [
                  _c("div", { staticClass: "code_tips" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("assets.vb.start.scan")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("qrcode", {
                    staticClass: "vb_qrcode",
                    attrs: {
                      options: _vm.qrcodeOpt,
                      text: _vm.vb && _vm.vb.uri
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "code_tips" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("assets.vb.start.downloadTips"))
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "action_get_app",
                        on: { click: _vm.getWallet }
                      },
                      [_vm._v(_vm._s(_vm.$t("assets.vb.start.download")) + "→")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "__btn __btn_all_in __pointer",
                  on: { click: _vm.createAcc }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("addAccount")) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tabName === "ledger"
          ? _c("div", { staticClass: "ledger" }, [
              _c("div", { staticClass: "code_container" }, [
                _c("div", { staticClass: "code_tips" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("assets.ledger.start.title")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "code_tips_introduction" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("assets.ledger.start.introductionUrl"),
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("assets.ledger.start.introduction")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("assets.ledger.start.connectErrorUrl"),
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("assets.ledger.start.connectError")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "__btn __btn_all_in __pointer",
                  on: {
                    click: function($event) {
                      return _vm.connectLedger()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("assets.ledger.connectLedger")) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tabName === "existingAcc"
          ? _c("div", { staticClass: "existing-acc" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside.includeChildrens",
                      value: _vm.hideAccountList,
                      expression: "hideAccountList",
                      modifiers: { includeChildrens: true }
                    }
                  ],
                  staticClass: "bottom __btn __pointer"
                },
                [
                  _c(
                    "div",
                    { on: { click: _vm.toggleAccountList } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.currAcc &&
                                !_vm.currAcc.activeAddr &&
                                !_vm.currAcc.isSeparateKey,
                              expression:
                                "currAcc && !currAcc.activeAddr && !currAcc.isSeparateKey"
                            }
                          ],
                          staticClass: "__btn __btn_input"
                        },
                        [
                          _c("div", { staticClass: "name __ellipsis" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.currAcc.name) +
                                "\n                        "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("account-item", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currAcc && _vm.currAcc.activeAddr,
                            expression: "currAcc && currAcc.activeAddr"
                          }
                        ],
                        staticClass: "no-border",
                        attrs: { account: _vm.currAcc }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        class: {
                          slide: true,
                          down: !_vm.isShowAccountList,
                          up: _vm.isShowAccountList
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("account-list", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowAccountList,
                        expression: "isShowAccountList"
                      }
                    ],
                    ref: "accList",
                    attrs: { clickAccount: _vm.chooseAccount }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bottom __btn __btn_input",
                  class: { active: !!_vm.password || _vm.inputItem === "pass" }
                },
                [
                  "password" === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        ref: "passInput",
                        attrs: {
                          autofocus: "",
                          placeholder: _vm.$t("create.input"),
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password)
                            ? _vm._i(_vm.password, null) > -1
                            : _vm.password
                        },
                        on: {
                          focus: function($event) {
                            return _vm.inputFocus("pass")
                          },
                          blur: function($event) {
                            return _vm.inputBlur("pass")
                          },
                          change: function($event) {
                            var $$a = _vm.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.password = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password = $$c
                            }
                          }
                        }
                      })
                    : "password" === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        ref: "passInput",
                        attrs: {
                          autofocus: "",
                          placeholder: _vm.$t("create.input"),
                          type: "radio"
                        },
                        domProps: { checked: _vm._q(_vm.password, null) },
                        on: {
                          focus: function($event) {
                            return _vm.inputFocus("pass")
                          },
                          blur: function($event) {
                            return _vm.inputBlur("pass")
                          },
                          change: function($event) {
                            _vm.password = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        ref: "passInput",
                        attrs: {
                          autofocus: "",
                          placeholder: _vm.$t("create.input"),
                          type: "password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          focus: function($event) {
                            return _vm.inputFocus("pass")
                          },
                          blur: function($event) {
                            return _vm.inputBlur("pass")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "__btn_list" }, [
                _c(
                  "span",
                  {
                    staticClass: "__btn __btn_border __pointer",
                    on: { click: _vm.createAcc }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("addAccount")) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "__btn __btn_all_in __pointer",
                    on: { click: _vm.login }
                  },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.isShowExisting
                                ? _vm.$t("btn.login")
                                : _vm.$t("create.finish")
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("loading", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLoading,
                          expression: "isLoading"
                        }
                      ],
                      attrs: { loadingType: "dot" }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tabName === "resotre"
          ? _c("restore", {
              ref: "restoreDom",
              attrs: {
                leftClick: _vm.createAcc,
                leftTxt: "createAcc",
                finishCb: _vm.showExisting
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_wrapper" }, [
      _c("img", {
        attrs: { src: require("assets/imgs/ledger_logo.svg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }